import InputDefault from "../../../../shared/Inputs/InputDefault";
import {useEffect, useState} from "react";
import axios from "axios";
import {diffDays} from "../../../../shared/functions/diffDays";
import {getCurrentDateInSeconds} from "../../../../shared/functions/getRandomId";
import Toaster, {ToasterProps} from "../../../../shared/Toaster/Toaster";

interface ICreator {
    codeCreator: string
    percentForReferral: number
    percentForCreator: number
    steamId: string
    cardWithdraw: string
    amountWithdraw: number
    dateStart: Date
    dateEnd: Date
}

const Referral = () => {
    const [loading, setLoading] = useState(true);
    const [clickReferral, setClickReferral ] = useState(false)
    const [referralCode, setReferralCode] = useState("")
    const [cardWithdraw, setCardWithdraw] = useState("")
    const [daysForEndReferral, setDaysForEndReferral] = useState(29)

    const [dataCreator, setDataCreator] = useState<ICreator>()
    const [formattedCard, setFormattedCard] = useState('');
    const [toastProps, setToastProps] = useState<ToasterProps | null>(null);


    const handleClick = () => {
        if (referralCode === "") {
            setToastProps({
                message: "Ключове поле не заповнене",
                type: "warning",
                id: getCurrentDateInSeconds()
            })
            return;
        }

        axios.post(`http://localhost:5000/referral`, {
            codeCreator: referralCode,
        }, {
            withCredentials: true,
        })
            .then(() => {
                setClickReferral(false);
                setReferralCode("");
            })
            .catch(error => {
                console.error("Помилка:", error);
                setClickReferral(false);
                setReferralCode("");
            });
    };

    useEffect(() => {
        axios.get(`http://localhost:5000/api/referral/creator`,{
            withCredentials: true
        })
        .then(({data}) => {
            setDataCreator(data)
            const formatted = data?.cardWithdraw?.replace(/(.{4})/g, '$1 ')
            setFormattedCard(formatted)
            setDaysForEndReferral(diffDays(data.dateEnd))
        })
    }, [])

    return (
        <>
            { dataCreator?.percentForCreator ? //Если человек является стримером(creator)
                <>
                    <div className="wrapper-input-transfer">
                        { dataCreator.cardWithdraw
                            ? // Если в базе уже есть номер карты для вывода
                            <div style={{width: "100%"}}>
                                <div className="card-withdraw">{ formattedCard }</div>
                                <div className="wrapper-button-transfer">
                                    <button className="button-buy">Змінити</button>
                                </div>
                            </div>

                            : // Если в базе ещё нету карты для вывода
                            <>
                                <InputDefault value={cardWithdraw} setValue={setCardWithdraw} placeholder={"Номер банківської картки"} />
                                <div className="wrapper-button-transfer">
                                    <button className="button-buy">Додати для виплат</button>
                                </div>
                            </>
                        }
                        {/*<div className="clue-transfer">Як відбуваються виплати?</div>*/}
                    </div>
                    <div className="no-payments">
                        <h3>
                            Ви є нашим партнером, дякую - {dataCreator.codeCreator} <span>🤝</span>
                        </h3>
                        <p>
                            Всі {dataCreator.percentForCreator}% поповнення ваших рефералів, надходять на баланс нижче
                        </p>
                        <div className="referral-bonus-info">
                            Ваш баланс на зняття - {dataCreator.amountWithdraw} UAH
                        </div>
                    </div>
                </>
                :
                <>
                    { dataCreator?.codeCreator //Если человек не является creator, а просто реферал активный
                        ?
                        <div className="no-payments">
                            <h3>
                                Найближчим часом ви реферал - {dataCreator.codeCreator} <span>🤝</span>
                            </h3>
                            <p>
                                Через {daysForEndReferral} днів потрібно буде запровадити код автора повторно!
                            </p>
                            <div className="referral-bonus-info">
                                Ваш бонус +{dataCreator.percentForReferral}% до поповнення балансу
                            </div>
                        </div>

                        : //Если человек не является creator, и не является рефералом
                        <>
                            <div className="wrapper-input-transfer">
                                <InputDefault value={referralCode} setValue={setReferralCode} placeholder={"referral code"} />
                                {/*<div className="clue-transfer">Як стати партнером проекту?</div>*/}
                            </div>
                            <div className="wrapper-button-transfer">
                                <button onClick={handleClick} className="button-buy">Застосувати</button>
                            </div>
                            <div className="no-payments">
                                <h3>
                                    Ви поки що не берете участі у реферальній програмі. <span>😕</span>
                                </h3>
                                <p>
                                    Щоб взяти, вам потрібний код
                                </p>
                            </div>
                        </>
                    }
                </>
            }
            {toastProps && <Toaster message={toastProps.message} type={toastProps.type} id={toastProps.id} />}
        </>
    );
};

export default Referral;